{
  "title": "Vänner",
  "playingNow": "Vänner spelar nu",
  "viewAll": "Visa alla",
  "score": "Resultat",
  "toPar": "Till par",
  "handicap": "HCP",
  "noFriends": "Du har inga vänner ännu. Börja med att lägga till via e-post eller QR-kod.",
  "searchDescription": "Skicka en vänförfrågan med e-postadress.",
  "searchPlaceholder": "E-post...",
  "sendRequest": "Skicka förfrågan",
  "requestSent": "Vänförfrågan skickad framgångsrikt!",
  "sentRequests": "Skickade förfrågningar",
  "accept": "Acceptera",
  "decline": "Avböj",
  "cancelRequest": "Avbryt förfrågan",
  "removeFriend": "Ta bort vän",
  "blockUser": "Blockera användare",
  "confirmRemove": "Är du säker på att du vill ta bort {{name}} från dina vänner?",
  "confirmBlock": "Är du säker på att du vill blockera {{name}}? Detta tar bort dem från dina vänner och förhindrar dem från att skicka förfrågningar.",
  "tabs": {
    "myFriends": "Mina vänner",
    "findFriends": "Hitta vänner",
    "qrConnect": "QR-anslutning"
  },
  "qr": {
    "title": "Vän QR-kod",
    "scanTitle": "Skanna QR-kod",
    "description": "Anslut med vänner personligen genom att generera en QR-kod eller skanna deras.",
    "generateCode": "Generera min QR-kod",
    "scanCode": "Skanna väns QR-kod",
    "instructions": "Visa denna QR-kod för din vän för att ansluta omedelbart.",
    "scanInstructions": "Placera QR-koden inom ramen för att skanna.",
    "usesRemaining": "Användningar kvar",
    "expiresAt": "Går ut",
    "generating": "Genererar QR-kod...",
    "processing": "Bearbetar...",
    "generateError": "Kunde inte generera QR-kod. Försök igen.",
    "cameraError": "Kan inte komma åt kameran. Kontrollera behörigheter.",
    "acceptError": "Kunde inte acceptera vänskap. Denna kod kan ha gått ut.",
    "tryAgain": "Försök igen"
  },
  "scorecard": {
    "course": "Bana",
    "teeSet": "Tee-set",
    "started": "Startad",
    "loadError": "Kunde inte ladda väns scorekort. Du kanske inte har behörighet att se det.",
    "backToFriends": "Tillbaka till vänner",
    "autoRefresh": "Uppdateras automatiskt var 2:a minut"
  },
  "removeFriendTitle": "Ta bort vän",
  "blockUserTitle": "Blockera användare",
  "sections": {
    "requests": "Vänförfrågningar",
    "friends": "Vänner"
  },
  "profile": {
    "roundsLabel": "Rundor",
    "averageLabel": "Genomsnittligt resultat",
    "bestLabel": "Bästa runda",
    "recentRounds": "Senaste rundorna",
    "noClub": "Ingen klubb",
    "showMore": "Visa mer",
    "noRounds": "Inga rundor ännu",
    "loadError": "Det gick inte att ladda kompisens profil.",
    "notFound": "Kompisen hittades inte.",
    "removeError": "Det gick inte att ta bort kompisen.",
    "blockError": "Det gick inte att blockera användaren.",
    "partialLoadError": "Det gick inte att ladda all information."
  }
}
